export default __webpack_public_path__ + "static/media/hootsHollow.c382bf1b.png";